
import Vue from 'vue'
import { consumeAccountSwitchNotice } from '@/utils/accountSwitchNotice'

const component = Vue.extend({
  mounted() {
    // アカウント切り替え検知でリロードした場合はここでメッセージを引き継いで表示する
    const notice = consumeAccountSwitchNotice()
    if (notice) {
      this.App.data.finished = notice
    }
  }
})

Vue.component('ASnackbar', component)
export default component
